const appSetting = {
  state: {
    projectName: "",
  },
  mutations: {
    projectName(state, payload) {
      state.projectName = payload;
    },
  },
  getters: {
    getAppsetting(state) {
      return state;
    },
  },
  actions: {},
};
export default appSetting;
